var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 .473H5a4.09 4.09 0 0 0-4.09 4.09v19.091A4.09 4.09 0 0 0 5 27.745h30a4.09 4.09 0 0 0 4.091-4.09V4.563a4.09 4.09 0 0 0-4.09-4.091ZM34.414 3.2 20.586 14.218c-.395.368-.777.368-1.254 0L5.586 3.2zM35 25.018H5c-.753 0-1.364-.61-1.364-1.364V5.136L17.56 16.222a3.57 3.57 0 0 0 2.468 1.01 3.4 3.4 0 0 0 2.332-.941L36.364 5.136v18.519A1.365 1.365 0 0 1 35 25.018"
  })));
};
export default SvgMail;